export const minusMonths = function (i: number): Date {
	return new Date(
		new Date().getFullYear(),
		new Date().getMonth() - i,
		new Date().getDate()
	);
};

export const yearStart = function (): Date {
	return new Date(new Date().getFullYear(), 0, 1);
};

export const dateEqual = function(d1: Date, d2: Date): boolean {
	if(!d1 || !d2){
		return !d1 && !d2;
	}

	return d1.getTime() === d2.getTime();
};